export default "__VITE_ASSET__ENJ26$w8__"